"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var commonLocations_exports = {};
__export(commonLocations_exports, {
  commonLocations: () => commonLocations
});
module.exports = __toCommonJS(commonLocations_exports);
var import_geometry = require("./geometry/index.js");
function commonLocation(bounds, center, zoom) {
  return { bounds, center, zoom };
}
const commonLocations = {
  greatBritain: commonLocation([-11.19056, 49.692546, 2.348194, 59.548095], (0, import_geometry.point)(-4.421183, 54.6203205), 6),
  london: commonLocation([-0.563049, 51.246444, 0.307617, 51.726178], (0, import_geometry.point)(-0.12, 51.505), 10),
  brighton: commonLocation([-0.246162, 50.805718, -0.073471, 50.905198], (0, import_geometry.point)(-0.1457802, 50.8237123), 16),
  singapore: commonLocation([103.583221, 1.199482, 104.096832, 1.476811], (0, import_geometry.point)(103.855262, 1.283319), 14)
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  commonLocations
});
//# sourceMappingURL=commonLocations.js.map
